import {css} from "styled-components"

export const mainStyles = css`
  ${({theme}) => css`
    font-family: ${theme.font.medium};
    color: ${theme.colors.greys.black};
    margin: 0;
    padding: 0;

    && a {
      padding: 0;
      color: ${theme.colors.primary1};
      font-family: ${theme.font.bold};
      &:hover {
        color: ${theme.colors.primary1};
        text-decoration: underline;
        box-shadow: none;
      }
    }
  `}
`

export const regularStyles = css`
  font-size: 16px;
  line-height: 26px;

  && a {
    font-size: 16px;
    line-height: 26px;
  }
`

export const largeStyles = css`
  font-size: 18px;
  line-height: 28px;

  && a {
    font-size: 18px;
    line-height: 28px;
  }
`

export const smallStyles = css`
  font-size: 14px;
  line-height: 22px;

  && a {
    font-size: 14px;
    line-height: 22px;
  }
`
